import {
	Drawer,
	DrawerBody,
	DrawerHeader,
	DrawerOverlay,
	DrawerContent,
	DrawerCloseButton,
	Flex,
	List,
	ListItem,
	Text,
} from '@chakra-ui/react'
import ButtonCTA from './../globalComponents/button/index'
import { declineHistoryQuery } from '../../hooks/activity.hooks'
import { useSharedContext } from './../../context/shared.context'
import { getDeclineTimeDate } from '../../utils/date.utils'
import { useQuery } from 'react-query'
import { getDeclineHistoryQueryKey } from '../../utils/queryKeyFactory'
import PropTypes from 'prop-types'
import { useLanguageContext } from './../../context/locale.context'

const WhatNextDeclined = ({ onClose, onChooseLead }) => {
	const {
		state: {
			activity: { activity_id, activity_type_id, activity_type_category_id },
		},
	} = useSharedContext()

	const {
		state: { locale },
	} = useLanguageContext()

	const declineHistoryParam = {
		activity_id,
		activity_type_id,
		activity_type_category_id,
		workflow_activity_id: activity_id,
		start_from: 0,
		limit_value: 50,
		form_id: 0,
	}

	const { data: declinedData } = useQuery(
		getDeclineHistoryQueryKey.activity_param(declineHistoryParam),
		() => declineHistoryQuery(declineHistoryParam)
	)

	return (
		<>
			<Drawer isOpen={true} placement='right' onClose={onClose} size='sm'>
				<DrawerOverlay />
				<DrawerContent>
					<DrawerCloseButton color='red.600' />
					<DrawerHeader>{locale['Decline History']}</DrawerHeader>

					<DrawerBody>
						<Flex flexDirection='column'>
							<ButtonCTA
								variant='sidebarButton'
								style={{ marginLeft: 'auto' }}
								fontSize='0.75rem'
								onClick={() => {
									onChooseLead()
								}}
							>
								{locale['Choose A Lead']}
							</ButtonCTA>
							<List spacing={3} w={'full'}>
								{declinedData?.map((list, index) => {
									return (
										<ListItem
											key={index}
											borderBottom={'1px'}
											borderBottomColor={'blackAlpha.300'}
										>
											<Text fontSize={'16px'} color={'black'}>
												{list?.operating_asset_first_name}
											</Text>
											<Text color={'blackAlpha.600'}>
												{list?.timeline_transaction_datetime &&
													getDeclineTimeDate(
														list?.timeline_transaction_datetime
													)}
											</Text>
										</ListItem>
									)
								})}
							</List>
						</Flex>
					</DrawerBody>
				</DrawerContent>
			</Drawer>
		</>
	)
}

WhatNextDeclined.propTypes = {
	onClose: PropTypes.func.isRequired,
	onChooseLead: PropTypes.func.isRequired,
}

export { WhatNextDeclined }
